module.exports = __webpack_public_path__ + "img/ui_log_in.1d9f2453.jpg";